import React, { useState, useEffect } from 'react';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../shared/ShowError';
import Laoding from '../shared/Laoding';


export default function ShowBuyProductSummary(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [loadingSummary, setLoadingSummary] = useState(true);
    const [summary, setSummary] = useState(null);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        setLoadingSummary(true);
        var buy = util.getBuy();
        if(buy == null){
            setRedirectUrl("/my-contracts/list");
            return;
        }
        var buyCompany = util.getBuyCompany();
        var buyParams = [];
        Object.keys(buy.parameters).forEach(key => {
            if (typeof buy.parameters[key] === "number") {
                buyParams.push({name:key, value:buy.parameters[key].toString()})
            }
            else{
                buyParams.push({name:key, value:buy.parameters[key]});
            }
        });
        var params = {
            login:util.getLoginDto(), 
            ipgType:0,
            type:0,
            contractId:"",
            companyDetail:{isPersonal:buyCompany.isPersonal, personNationalId:buyCompany.personNationalId, economicCode:buyCompany.economicCode,companyNationalId:buyCompany.companyNationalId, title:buyCompany.title},
            cityId:buyCompany.city.id,
            productId:buy.productId,
            modules:buy.modules,
            parameters:buyParams,
            discountToken:buy.discountToken,
            reagentMobile:"",
            fixAmount:0,
            otherSystemIdentity:util.getOtherSystemDetail().otherSystemIdentity
        };
        var url = config.Server+`/payment/product/buy/summary/get`;
        console.log("params in show summary is>", params);
        console.log("url in show summary is>", url);
        
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("resopnse is> ", response);
                setSummary(response);
                setLoadingSummary(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                //setLoading(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            //setLoading(false);
        });
    }, []);
    
    const onContinueButtonClick = function(){
        util.saveIpgTransactionAmount(summary.paymentAmount);
        util.saveIpgTransactionType(util.WallerTransactionTypes.BuyProduct);
        util.saveBeforeIpgUrl("BuyProductSummary");
        setRedirectUrl("/ipg/select");
    }
    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        (summary == null)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت خلاصه خرید..." />
                </Col>
            </Row>
        </>
        :
        <>
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px", position:"relative"}}>
                
                <Col className="d-flex justify-content-center align-items-center" style={{}}>
                    <Col md={3} style={{border:"1px solid #b0b0b0", padding:"10px", borderRadius:"10px", position:"relative"}}>
                        <img src={require("../lib/images/back.png")} alt='برگشت' onClick={()=>{navigate("/get-company-detail")}} style={{width:"48px", height:"32px", position:"absolute", top:"5px", right:"10px", cursor:"pointer"}} />
                        <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto"}}>
                            <tbody>
                                <tr>
                                    <td style={{width:"100%", textAlign:"center"}} colSpan={2}>
                                        <img src={require('../lib/images/hana.webp')} style={{width:"64px"}} />
                                        {/* <span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user"></span> */}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.5em", textAlign:"center"}} colSpan={2}>خلاصه سفارش محصول</td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{border:"1px solid #b0b0b0", padding:"5px"}}>محصول</td>
                                    <td style={{border:"1px solid #b0b0b0", padding:"5px"}}>{summary.productName}</td>
                                </tr>
                                <tr>
                                    <td style={{border:"1px solid #b0b0b0", padding:"5px"}}>ماژول ها</td>
                                    <td style={{border:"1px solid #b0b0b0", padding:"5px"}}>{summary.modules}</td>
                                </tr>
                                <tr>
                                    <td style={{border:"1px solid #b0b0b0", padding:"5px"}}>پارامترها</td>
                                    <td style={{border:"1px solid #b0b0b0", padding:"5px"}}>
                                        {
                                        summary.parameters.map((p, pInd)=>{
                                            return(
                                                <>
                                                    {p}<br/>
                                                </>
                                            )
                                        })
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{border:"1px solid #b0b0b0", padding:"5px"}}>نام موسسه</td>
                                    <td style={{border:"1px solid #b0b0b0", padding:"5px"}}>{summary.companyName}</td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr><td colSpan={2} style={{borderBottom:"1px dashed #b0b0b0"}}>&nbsp;</td></tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{border:"1px solid #b0b0b0", padding:"5px"}}>قیمت محصول</td>
                                    <td style={{border:"1px solid #b0b0b0", padding:"5px"}}>{util.SeperatePrice(summary.productPrice)}</td>
                                </tr>
                                {
                                   summary.discountValue>0?
                                   <>
                                <tr>
                                    <td style={{border:"1px solid #b0b0b0", padding:"5px"}}>تخفیف</td>
                                    <td style={{border:"1px solid #b0b0b0", padding:"5px", backgroundColor:"#a8d4a8ff", fontWeight:"bold"}}>{util.SeperatePrice(summary.discountValue)}</td>
                                </tr>
                                <tr>
                                    <td style={{border:"1px solid #b0b0b0", padding:"5px"}}>مبلغ پس از تخفیف</td>
                                    <td style={{border:"1px solid #b0b0b0", padding:"5px"}}>{util.SeperatePrice(summary.pureAmount)}</td>
                                </tr>
                                   </> 
                                   :
                                   <></>
                                }
                                <tr>
                                    <td style={{border:"1px solid #b0b0b0", padding:"5px"}}>ارزش افزوده</td>
                                    <td style={{border:"1px solid #b0b0b0", padding:"5px"}}>{util.SeperatePrice(summary.tax)}</td>
                                </tr>
                                <tr>
                                    <td style={{border:"1px solid #b0b0b0", padding:"5px", fontSize:"1.3rem", color:"#FFF", backgroundColor:"#555"}}>مبلغ نهائی</td>
                                    <td style={{border:"1px solid #b0b0b0", padding:"5px", fontSize:"1.3rem", color:"#FFF", backgroundColor:"#555"}}>{util.SeperatePrice(summary.paymentAmount)}</td>
                                </tr>
                                <tr>
                                    <td style={{border:"1px solid #b0b0b0", padding:"5px"}} colSpan={2}>{summary.paymentChar}</td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}} colSpan={2}>
                                        <Button severity="success" onClick={()=>{onContinueButtonClick()}} style={{borderRadius:"5px"}}>&nbsp;&nbsp;تائید سفارش و ادامه&nbsp;&nbsp;</Button>
                                        
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>

                            </tbody>
                        </table>
                    </Col>
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}